import { render, staticRenderFns } from "./CakeItemSummary.vue?vue&type=template&id=4c3bee7f&"
import script from "./CakeItemSummary.vue?vue&type=script&lang=js&"
export * from "./CakeItemSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports